var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTftGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tft-grey_svg__clip0_3017_7714)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tft-grey_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H2v16h16V2z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tft-grey_svg__a)",
    fill: "#CDDCFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.56 9.932c2.224 2.044 2.22 4.168 2.22 4.168-.83-1.788-1.868-2.22-1.868-2.22 2.324 3.034.08 3.4.08 3.4s-3.528.846-7.856-3.162C1.81 8.11 6.024 7.056 6.024 7.056s-4.332.292-2.156 4.148c2.436 3.908 7.258 5.452 7.258 5.452s-2.898-.02-5.31-1.888c0 0 3.082 3.05 7.856 3.226 4.774.176 3.432-3.848 3.432-3.848s-1.106-2.688-3.544-4.216v.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.066 5.23l-.02 7.232c1.536 1.1 2.89 1.572 3.908 1.758l.02-8.988h4.172L17.756 2H2.244l1.624 3.23h4.198z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tft-grey_svg__clip0_3017_7714"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/_/_/shared/assets/games/tft-grey.svg";
export { SvgTftGrey as ReactComponent };